import React from "react";
import { QrCode, Phone, HeartPulse, Award, Users, Lock } from "lucide-react";
import { t } from "../../i18n/translations";

const benefits = [
  {
    icon: QrCode,
    titleKey: "benefits.b1Title",
    descKey: "benefits.b1Desc",
    color: "bg-red-50 text-red-600 border-red-100",
  },
  {
    icon: Phone,
    titleKey: "benefits.b2Title",
    descKey: "benefits.b2Desc",
    color: "bg-orange-50 text-orange-600 border-orange-100",
  },
  {
    icon: HeartPulse,
    titleKey: "benefits.b3Title",
    descKey: "benefits.b3Desc",
    color: "bg-teal-50 text-teal-600 border-teal-100",
  },
  {
    icon: Award,
    titleKey: "benefits.b4Title",
    descKey: "benefits.b4Desc",
    color: "bg-amber-50 text-amber-600 border-amber-100",
  },
  {
    icon: Users,
    titleKey: "benefits.b5Title",
    descKey: "benefits.b5Desc",
    color: "bg-blue-50 text-blue-600 border-blue-100",
  },
  {
    icon: Lock,
    titleKey: "benefits.b6Title",
    descKey: "benefits.b6Desc",
    color: "bg-emerald-50 text-emerald-600 border-emerald-100",
  },
];

const BenefitsGrid = () => {
  return (
    <section id="benefits" className="py-20 lg:py-28 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-white text-slate-600 rounded-full px-4 py-1.5 text-xs font-bold uppercase tracking-wider mb-4 border border-slate-200 shadow-sm">
            {t("benefits.badge")}
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-slate-900 tracking-tight mb-4">
            {t("benefits.title")}
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">{t("benefits.subtitle")}</p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {benefits.map((benefit, idx) => {
            const Icon = benefit.icon;
            return (
              <div
                key={idx}
                className="bg-white rounded-lg p-7 border border-slate-200 hover:border-slate-300 hover:shadow-md transition-colors duration-150 group"
              >
                <div className={`w-12 h-12 rounded-lg flex items-center justify-center border mb-5 ${benefit.color}`}>
                  <Icon size={22} />
                </div>
                <h3 className="text-lg font-bold text-slate-900 mb-2">{t(benefit.titleKey)}</h3>
                <p className="text-sm text-slate-600 leading-relaxed">{t(benefit.descKey)}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default BenefitsGrid;
